import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderBack from '../components/HeaderBack';
import ProfileResetPassword from '../../common/forms/ProfileResetPassword';
import ProfileChangePhoneNumber from '../../common/forms/ProfileChangePhoneNumber';
import TransHelper from 'components/common/translations/TransHelper';

class DesktopView extends Component {

  constructor(props) {
    super(props)
    this.locale = props.locale;
  }

  trans = (key) => {
    return TransHelper.translate(this.locale, "content.form." + key);
  }

  render() {

    return (
      <div className="content" style={{ padding: '0' }}>
        {this.props.isStandardAccount &&
          <div className="grid-layout">
            <div className="grid-layout__item grid-layout__item--desc grid-layout__item--middle">
              <HeaderBack locale={this.props.locale} />
              <div className="content__desc">
                <h2 className="heading-icon">
                  <FontAwesomeIcon
                    icon={['fas', 'lock']}
                    size="lg"
                  />{this.trans('changePassword')}
                </h2>
                <ProfileResetPassword locale={this.locale} />
              </div>
            </div>

            <div className="grid-layout__item grid-layout__item--desc grid-layout__item--middle">
              <div className="content__desc">
                <h2 className="heading-icon">
                  <FontAwesomeIcon
                    icon={['fas', 'mobile-alt']}
                    size="lg"
                  />{this.trans('changePhoneNumber')}
                  </h2>
                <ProfileChangePhoneNumber locale={this.locale}  />
              </div>
            </div>
          </div>
        }

        {this.props.isStandardAccount == false &&
          <Fragment>
            <HeaderBack locale={this.props.locale} />
            <div className="content__desc">
              <h2 className="heading-icon">
                <FontAwesomeIcon
                  icon={['fas', 'mobile-alt']}
                  size="lg"
                />{this.trans('changePhoneNumber')}
                </h2>
              <ProfileChangePhoneNumber locale={this.locale} />
            </div>
          </Fragment>
        }
      </div>
    );

  }
}

export default DesktopView;
